import React, { useEffect, useState } from "react";
import { practiceApi } from "../../lib/practiceApi";

const plain = value => {
  const area = document.createElement("textarea"); area.innerHTML = String(value || ""); return area.value;
};

export const QuoteParties = ({ quote, issuer = {}, onChange }) => {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const { id, issuer_type, signer_id, signer_name, representative_id } = quote;
  useEffect(() => {
    let active = true;
    practiceApi(`/estimates/${id}/issuer-preview`, { method: "POST", body: JSON.stringify({ data: {
      issuer_type: issuer_type || "", signer_id: signer_id || "", signer_name: signer_name || "", representative_id: representative_id || "" } }) })
      .then(result => { if (active) { setPreview(result); setError(""); } }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [id, issuer_type, signer_id, signer_name, representative_id]);
  const isCompany = (issuer_type || issuer.default_type) === "societa";
  return <div className="field-wide quote-parties" data-testid="quote-parties">
    <div className="practice-form-grid">
      <label>Soggetto che assume l’incarico<select data-testid="quote-issuer-type" disabled={quote.documents_locked} value={issuer_type || ""} onChange={e => onChange({ issuer_type: e.target.value })}>
        <option value="">{`Predefinito: ${issuer.default_type === "societa" ? issuer.company_name || "Società" : issuer.professional_name || "Professionista"}`}</option>
        <option value="professionista">Professionista</option><option value="societa">Società</option>
      </select></label>
      {isCompany && <>
        <label>Rappresentante che firma l’incarico<select data-testid="quote-representative" disabled={quote.documents_locked} value={representative_id || ""} onChange={e => onChange({ representative_id: e.target.value })}>
          <option value="">Predefinito dell’anagrafica societaria</option>{(issuer.representatives || []).map(p => <option key={p.id} value={p.id}>{`${p.name} · ${p.role}`}</option>)}
        </select></label>
        <label>Progettista e firmatario degli elaborati<select data-testid="quote-signer" disabled={quote.documents_locked} value={signer_id || (issuer.signers || []).find(p => p.name === signer_name)?.id || ""} onChange={e => onChange({ signer_id: e.target.value, signer_name: "" })}>
          <option value="">Predefinito dell’anagrafica professionisti</option>{(issuer.signers || []).map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select></label>
      </>}
    </div>
    {error && <p className="error" role="alert" data-testid="quote-parties-error">{error}</p>}
    {preview && <div className="quote-parties-preview" data-testid="quote-parties-preview">
      {[[preview.band_label, preview.kv], [preview.responsible_label, preview.responsible_kv]].filter(([label, rows]) => label && rows).map(([label, rows], section) =>
        <section key={label} data-testid={`quote-party-section-${section}`}><h3>{label}</h3><dl>{rows.map(([key, value]) => <div key={key}><dt>{key}</dt><dd>{plain(value)}</dd></div>)}</dl></section>)}
      {(preview.warnings || []).map((warning, index) => <p className="practice-notice" role="alert" key={warning} data-testid={`quote-party-warning-${index}`}>{warning}</p>)}
    </div>}
  </div>;
};